import type { RotationCalendar } from "@shared/models/rotation-calendar"
import { cloneDeep, filter, map } from "lodash-es"

export function updateToNewVersion(parentRc: RotationCalendar, childRc: RotationCalendar) {
  // Const is necesary so TS believes the check in the next line
  const datesLastChangedOn = parentRc.attributes.datesLastChangedOn
  if (datesLastChangedOn === null) {
    throw new Error("Parent Rotation Calendar must have `datesLastChangedOn` set")
  }
  let oldDates = filter(childRc.attributes.dates, (date) => {
    return date.attributes.dateString < datesLastChangedOn
  })
  let newDates = map(
    filter(parentRc.attributes.dates, (date) => {
      return date.attributes.dateString >= datesLastChangedOn
    }),
    (date) => cloneDeep(date)
  )
  // Returning this as fields so we can apply them in a patch or
  // set them on the rotationCalendar.attributes.
  return {
    dateAnnotations: cloneDeep(parentRc.attributes.dateAnnotations),
    rotations: cloneDeep(parentRc.attributes.rotations),
    schoolDays: cloneDeep(parentRc.attributes.schoolDays),
    semesters: cloneDeep(parentRc.attributes.semesters),
    dates: [...oldDates, ...newDates],
  }
}
